import { render, staticRenderFns } from "./licenseTable.vue?vue&type=template&id=08cf7677&scoped=true&"
import script from "./licenseTable.vue?vue&type=script&lang=js&"
export * from "./licenseTable.vue?vue&type=script&lang=js&"
import style0 from "./licenseTable.vue?vue&type=style&index=0&id=08cf7677&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cf7677",
  null
  
)

export default component.exports